import { AdditionalContentAccordionGroup } from '@components/common/additional-content-accordion-group/additional-content-accordion-group';
import scrollSectionStyles from '@components/common/scroll-section/scroll-section.module.css';
import cn from 'classnames';
import { Element } from 'react-scroll';

const SettoriIndustriaSezione = ({
  title = '',
  subtitle = '',
  body = {},
  darkTheme = true,
  urlImage = '',
  sectionName = '',
  additionalContent = [],
  categoryId = ''
}) => {
  const backgroundImage = urlImage
    ? `${darkTheme ? 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6)), ' : ''}url(${urlImage})`
    : undefined;

  return (
    <Element name={sectionName}>
      <div
        id={categoryId}
        className={cn(scrollSectionStyles.hero, 'snf-bg-repeat-no-repeat snf-text-color-black ', {
          'snf-text-color-white': darkTheme
        })}
        style={{ backgroundImage }}
      >
        <div
          className={`container-fluid ${scrollSectionStyles.padding} ${scrollSectionStyles.containerDetail} px-3 px-md-5 py-5`}
        >
          <div className="row">
            <div className="col-12 snf-font-35 snf-font-w6 ">{title}</div>
          </div>
          <div className="row">
            <div className="col-12 snf-font-24 snf-font-w6 ">{subtitle}</div>
          </div>
          <div className="row">
            <div className="col-12 col-md-10">
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={body}
              />
            </div>
          </div>
          <AdditionalContentAccordionGroup
            translations={{ additionalContent }}
            darkTheme={darkTheme}
            id={sectionName}
          />
        </div>
      </div>
    </Element>
  );
};

SettoriIndustriaSezione.displayName = 'Settori di Industria sezione';
export { SettoriIndustriaSezione };
